import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Wrench, Droplets, Zap, RefreshCw, Hammer } from 'lucide-react';
import { motion } from 'framer-motion';

const services = [
  {
    icon: Wrench,
    title: 'Appliance Repair',
    bullets: [
      'Refrigerators & Freezers',
      'Microwaves & Stoves',
      'Cooktops & Wall Ovens',
      'Dishwashers',
      'Washers & Dryers'
    ]
  },
  {
    icon: Droplets,
    title: 'Plumbing',
    bullets: [
      'Leaks & clogs',
      'Fixture installs',
      'Water heater service',
      'Drain cleaning',
      'Emergency calls available'
    ]
  },
  {
    icon: Zap,
    title: 'Electrical',
    bullets: [
      'Outlets & switches',
      'Lighting installation',
      'Panel upgrades',
      'Ceiling fan installs',
      'Expert troubleshooting'
    ]
  },
  {
    icon: RefreshCw,
    title: 'Refurbished Appliances',
    bullets: [
      'Quality used appliances',
      'Professionally inspected',
      'Cleaned & restored',
      'Affordable pricing',
      'Warranty included'
    ]
  },
  {
    icon: Hammer,
    title: 'Handyman Services',
    bullets: [
      'Minor carpentry',
      'Fixture adjustments',
      'Drywall repairs',
      'Door & window fixes',
      'General home repairs'
    ]
  }
];

export const Services = () => {
  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 presidential-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold text-white mb-4">
            Our Services
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto">
            Professional home services you can rely on
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Card
                  data-testid="services-card"
                  className="h-full border border-slate-700 rounded-xl p-5 bg-slate-800/50 hover:bg-slate-800/70 hover:border-slate-600 hover:-translate-y-0.5 transition-all duration-200"
                >
                  <CardHeader className="p-0 mb-4">
                    <div className="h-12 w-12 rounded-lg bg-slate-400/10 flex items-center justify-center mb-3">
                      <Icon className="h-6 w-6 text-slate-300" aria-hidden="true" />
                    </div>
                    <CardTitle className="text-lg font-semibold text-white">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <ul className="space-y-2">
                      {service.bullets.map((bullet, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-slate-400">
                          <span className="mt-2 h-1.5 w-1.5 rounded-full bg-slate-300 flex-shrink-0" />
                          {bullet}
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-slate-400 italic">
            Our technicians handle most jobs in-house. When we can't, we connect you with trusted, vetted partners we stand behind.
          </p>
        </div>
      </div>
    </section>
  );
};